import { useContext } from "react";

import { FeatureFlagsContext } from "./feature-flags-context";

/** Slice 11 live credential flow. False when LaunchDarkly is on and the flag is off or missing. */
export function useLiveCredentialsEnabled(): boolean {
  return useContext(FeatureFlagsContext).liveCredentialsEnabled;
}

/** Imported sandbox credentials without a test location. False when LaunchDarkly is on and the flag is off or missing. */
export function useImportedSandboxCredentialsEnabled(): boolean {
  return useContext(FeatureFlagsContext).importedSandboxCredentialsEnabled;
}

/** Imported live credentials support notice. False when LaunchDarkly is on and the flag is off or missing. */
export function useImportedCredentialsSupportEnabled(): boolean {
  return useContext(FeatureFlagsContext).importedCredentialsSupportEnabled;
}

/** False while LaunchDarkly still evaluates flags for the current identity. */
export function useFeatureFlagsResolved(): boolean {
  return useContext(FeatureFlagsContext).flagsResolved;
}
